var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.61539C0.67 8.61539 3.70205e-07 7.89385 4.09276e-07 7C4.48347e-07 6.10615 0.67 5.38462 1.5 5.38462C2.33 5.38462 3 6.10615 3 7C3 7.89385 2.33 8.61539 1.5 8.61539ZM3 12.3846C3 11.4908 2.33 10.7692 1.5 10.7692C0.67 10.7692 2.12978e-07 11.4908 1.73907e-07 12.3846C1.34836e-07 13.2785 0.67 14 1.5 14C2.33 14 3 13.2785 3 12.3846ZM3 1.61538C3 0.721538 2.33 -2.92866e-08 1.5 -6.55671e-08C0.670001 -1.01848e-07 6.83716e-07 0.721538 6.44645e-07 1.61538C6.05574e-07 2.50923 0.67 3.23077 1.5 3.23077C2.33 3.23077 3 2.50923 3 1.61538Z",
    fill: "#c3c5e0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDot);
export default __webpack_public_path__ + "static/media/verticalDot.94ebe30d8e0ad1b2e948218702da5eae.svg";
export { ForwardRef as ReactComponent };